<template>
  <div class="home">

    <div class="row">
      <div class="col-md-12">
        <div class="row">

          <!-- First card -->
          <div class="col-md-4">
            <div class="alert alert-home-box card-shadow radius-0-5" role="alert">
              <span class="alert-home-box-icon">
                <font-awesome-icon icon="user"/>
              </span>
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-lg-4 col-md-5">
                      <div class="logo-container">
                        <img v-bind:src="getProfileAvatar"
                             class="rounded-circle"
                             width="100"
                             height="100"
                             qid="profile-photo"
                             id="avatar"
                        >
                        <div class="upload-helper-home rounded-circle">
                          <label class="mr-3 upload">
                            <input type="file"
                                   name="fileupload"
                                   value="fileupload"
                                   id="file"
                                   @change="onFileChange"
                            >
                            <font-awesome-icon icon="cloud-upload-alt" class="cursor-pointer" />
                          </label>
                          <span @click="removePhoto">
                            <font-awesome-icon icon="trash-alt" class="cursor-pointer"/>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="float-left col-lg-8 col-md-7">
                      <h5 qid="profile-name"
                          class="mt-2"
                          @dblclick="showNameInputFunction"
                          @keydown.esc="hideNameInputFunction"
                          v-if="!showNameInput"
                      >
                        <span v-b-tooltip.hover :title="$t('system.click_to_edit')">
                          {{ user.name }}
                        </span>
                      </h5>
                      <b-form-input
                        qid="homepage-user-name"
                        type="text"
                        v-model="userName"
                        v-if="showNameInput"
                        ref="nameInput"
                        v-on:keyup.enter="saveName"
                        @keydown.esc="hideNameInputFunction"
                        @focusout="hideNameInputFunction"
                        class="mb-1"
                      ></b-form-input>
                      <p qid="profile-email" class="mb-2 text-muted text-normal">
                        <span class="text-muted mr-2">
                          <font-awesome-icon icon="envelope" />
                        </span>
                        {{ user.email }}
                      </p>
                      <p qid="profile-phone"
                         class="mb-2 text-muted text-normal"
                         @dblclick="showPhoneInputFunction"
                         @keydown.esc="hidePhoneInputFunction"
                         v-if="!showPhoneInput"
                      >
                        <span class="text-muted mr-2">
                          <font-awesome-icon icon="phone" />
                        </span>
                        <span v-if="user.phone" v-b-tooltip.hover :title="$t('system.click_to_edit')">
                          {{ user.phone }}
                        </span>
                        <span v-if="!user.phone" v-b-tooltip.hover :title="$t('system.click_to_edit')">
                          {{ $t('system.add_phone_label') }}
                        </span>
                      </p>
                      <b-form-input
                        qid="homepage-user-name"
                        type="text"
                        v-model="userPhone"
                        v-if="showPhoneInput"
                        ref="phoneInput"
                        v-on:keyup.enter="savePhone"
                        @keydown.esc="hidePhoneInputFunction"
                        @focusout="hidePhoneInputFunction"
                        class="mb-2"
                      ></b-form-input>
                      <p qid="profile-organization" class="text-muted text-normal" v-if="user.organization">
                        <span class="text-muted mr-2">
                          <font-awesome-icon icon="sitemap" />
                        </span>
                        <span>
                          {{ user.organization.name }}
                        </span>
                      </p>
                      <p qid="profile-link">
                        <router-link
                            :to="{ name: 'profile', params: { slug: getUser.slug }}"
                            qid="user-profile-link"
                        >
                          {{ $t('system.view_my_activities') }}
                        </router-link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="col-sm-4" v-if="getClient.id && !getClient.projectModule">
            <div class="alert alert-processing-activities-1 card-shadow radius-0-5" role="alert">
              <span class="alert-processing-activities-1-icon">
                <font-awesome-icon icon="rocket"/>
              </span>
              <h5 class="mt-2 position-relative" style="z-index:1;">
                {{ $t('processes.processing_activities.first_card_title') }}
              </h5>
              <p style="min-height: 70px;z-index:1;" class="text-normal position-relative">
                {{ $t('processes.processing_activities.first_card_description') }}
              </p>
              <div class="mt-4" style="z-index:1;">
                <span v-if="getGuide('process_list_page')">
                  <GuideButton
                      :text="$t('processes.processing_activities.guide_button_label')"
                      type="secondary"
                      :guide="getGuide('process_list_page')"
                  ></GuideButton>
                </span>
              </div>
            </div>
          </div>

          <div class="col-sm-4" v-if="getClient.id && !getClient.projectModule">
            <div class="alert alert-processing-activities-2 card-shadow radius-0-5" role="alert">
              <span class="alert-processing-activities-2-icon">
                <font-awesome-icon icon="calendar-alt"/>
              </span>
              <h5 class="mt-2 position-relative" style="z-index:1;">
                {{ $t('processes.processing_activities.second_card_title') }}
              </h5>
              <p style="min-height: 70px;z-index:1;" class="text-normal position-relative">
                {{ $t('processes.processing_activities.second_card_description') }}
              </p>
              <div class="mt-4 position-relative" style="z-index:1;">
                <CreateProjectModal
                    class=""
                    v-if="getClient.projectModule"
                    type="update"
                    :types="types"
                    scope="processingActivities"
                ></CreateProjectModal>
                <a class="btn btn-secondary"
                   href="https://www.complyon.com/project-module"
                   qid="risk-read-more"
                   target="_blank"
                   v-else
                >
                  <span class="side-nav--text">
                    {{ $t('system.read_more') }}
                  </span>
                </a>
              </div>
            </div>
          </div>


          <!-- Second card -->
          <div class="col-md-4" v-if="getClient.id && getClient.projectModule">
            <div class="alert alert-home-box card-shadow radius-0-5">
              <div class="row">
                <div class="col-md-7">
                  <h5 class="card-title">
                    {{ $t('system.task_performance_title') }}
                  </h5>
                  <p class="card-text text-normal">
                    {{ $t('system.task_performance_description') }}
                  </p>
                </div>
                <div class="col-md-5" style="padding-left:0;">
                  <div id="gauge" class="gauge-container"></div>
                </div>
              </div>
            </div>
          </div>


          <!-- Third card -->
          <div class="col-md-4" v-if="getClient.id && getClient.projectModule">
            <div class="alert alert-home-box card-shadow radius-0-5">
              <span class="float-right" v-if="getClient.projectModule">
                <font-awesome-icon
                    icon="medal"
                    class="ml-2"
                    size="lg"
                    style="color: gold;"
                    v-if="organizations_position && topOrganizations[organizations_position-1] && topOrganizations[organizations_position-1].medal == 'gold'"
                />
                <font-awesome-icon
                    icon="medal"
                    class="ml-2"
                    size="lg"
                    style="color: silver;"
                    v-else-if="organizations_position && topOrganizations[organizations_position-1] && topOrganizations[organizations_position-1].medal == 'silver'"
                />
                <font-awesome-icon
                    icon="medal"
                    class="ml-2"
                    size="lg"
                    style="color: #CD7F32;"
                    v-else-if="organizations_position && topOrganizations[organizations_position-1] && topOrganizations[organizations_position-1].medal == 'bronze'"
                />
              </span>
              <h5 class="card-title">
                {{ $t('system.top_organizations_title') }}
              </h5>
              <div class="row">
                <div class="col-md-8" style="padding-right:0">
                  <p class="card-text text-normal">
                    {{ $t('system.top_organizations_description') }}
                  </p>
                </div>
                <div class="col-md-4" style="padding-left:0" v-if="getClient.projectModule">
                  <div v-if="organizations_position && organizations_total" class="text-success text-right" style="margin-top: -30px;">
                    <span style="font-size: 70px;">
                      {{organizations_position}}
                    </span>
                    <span style="font-size: 16px;">
                      {{ $t('system.of') }} {{organizations_total}}
                    </span>
                  </div>
                </div>
                <div class="col-md-12 text-center mt-2" v-if="!loadingOrganizations && topOrganizations.length && getClient.projectModule">
                  <span class="text-dark cursor-pointer" @click="openTopOrganizationsList()">
                    {{ $t('system.view_more') }}
                    <font-awesome-icon icon="chevron-up" v-if="topOrganizationListOpened"/>
                    <font-awesome-icon icon="chevron-down" v-if="!topOrganizationListOpened"/>
                  </span>
                  <div v-if="topOrganizationListOpened" class="mt-4">
                    <div v-for="(organization, index) in topOrganizations"
                         qid="modal-users-list"
                         class="row mt-3"
                         :key="index"
                    >
                      <div class="col-md-12" :class="[ index+1 == organizations_position ? 'selected-item' : 'non-selected-item']">
                        <div class="col-md-8 float-left text-left">
                          <span style="width: 30px; display: inline-block">
                            <font-awesome-icon
                                icon="medal"
                                class="ml-2"
                                size="small"
                                style="color: gold;"
                                v-if="organization.medal == 'gold'"
                            />
                            <font-awesome-icon
                                icon="medal"
                                class="ml-2"
                                size="small"
                                style="color: silver;"
                                v-else-if="organization.medal == 'silver'"
                            />
                            <font-awesome-icon
                                icon="medal"
                                class="ml-2"
                                size="small"
                                style="color: #CD7F32;"
                                v-else-if="organization.medal == 'bronze'"
                            />
                          </span>

                          {{ organization.name }}
                        </div>
                        <div class="col-md-4 float-right">
                          {{ organization.percentage }}%
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <b-tabs class="mt-3">

      <!-- Projects tab -->
      <b-tab active :title-link-class="unreadCount ? 'position-relative pr-5' : 'position-relative'" v-if="getClient && getClient.id && getClient.projectModule">
        <template v-slot:title>
          {{$t('tasks.title')}}
          <span class="tab-item-badge ml-2" v-if="unreadCount">
            {{unreadCount}}
          </span>
        </template>

        <!-- Projects widget -->
        <div v-if="getClient.projectModule">
          <div class="row" :class="{'table-with-filters': filterOpened}">
            <div class="col-md-12 ">
              <div class="row">

                <!-- My projects -->
                <div
                     class="col-md-6 table-container-dual"
                     v-if="getClient.projectModule && (navigation.project || isGranted(permissions.MEASURE_CREATE))"
                >
                  <div class="card mt-3 pagination-margin" style="z-index:0;">
                    <div class="card-body">
                      <h5 class="mt-2">
                        <CreateProjectModal
                            class="float-right"
                            @reloadContent="loadProjects()"
                        ></CreateProjectModal>

                        <router-link
                            class="btn btn-secondary cursor-pointer float-right"
                            to="/projects/gantt"
                            qid="home-gantt-link"
                        >
                          <span class="">
                            <font-awesome-icon icon="chart-gantt" />
                            {{ $t('projects.gantt_overview_list_title') }}
                          </span>
                        </router-link>

                        {{ $t('tasks.my_projects') }}
                      </h5>

                      <div>
                        <span v-if="getGuide('my_todo_list_page')">
                          <GuideButton :guide="getGuide('my_todo_list_page')"></GuideButton>
                        </span>
                      </div>

                      <table class="table table-responsive-md table-list-secondary-slim">
                        <thead>
                          <tr>
                            <th scope="col">
                              {{ $t('projects.table.name') }}
                            </th>
                            <th scope="col">
                              {{ $t('projects.table.due_date') }}
                            </th>
                            <th scope="col">
                              {{ $t('table.progress') }}
                            </th>
                            <th scope="col" width="150"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(project, index) in tableProjects" :key="'tableProjects-row-' + index" :id="'tableProjects-row-' + index">

                            <b-popover
                                :target="'tableProjects-row-' + index"
                                boundary="viewport"
                                triggers="hover"
                                placement="top"
                                :delay="{ show: 500, hide: 0 }"
                            >
                              <div v-if="project.description" class="mt-2">
                                <span class="text-bold">
                                  {{ $t('maintenance.data_objects.table.description') }}:
                                </span>
                                <br>
                                {{ project.description | truncate(200)}}
                                <br>
                                <br>
                              </div>

                              <div v-if="project.type">
                                <span class="text-bold">
                                  {{ $t('table.type') }}:
                                </span>
                                <span>
                                  <br>
                                  <span v-if="project.type == 'update'" class="badge">
                                    <font-awesome-icon icon="sync-alt" style="color:#081F26;"/>
                                    {{ $t('projects.view.update_label') }}
                                  </span>
                                  <span v-if="project.type == 'validation'" class="badge">
                                    <font-awesome-icon icon="check-circle" style="color:#081F26;"/>
                                    {{ $t('projects.view.validation_label') }}
                                  </span>
                                  <span v-if="project.type == 'control'" class="badge">
                                    <font-awesome-icon icon="shield-alt" style="color:#081F26;"/>
                                    {{ $t('projects.view.control_label') }}
                                  </span>
                                  <span v-if="project.type == 'security_measure'" class="badge">
                                    <font-awesome-icon icon="shield-alt" style="color:#081F26;"/>
                                    {{ $t('projects.view.security_measure_label') }}
                                  </span>
                                  <span v-if="project.type == 'risk_assessment'" class="badge">
                                    <font-awesome-icon icon="file-alt" style="color:#081F26;"/>
                                    {{ $t('maintenance.assessments.type.risk_assessment') }}
                                  </span>
                                  <span v-if="project.type == 'control_assessment'" class="badge">
                                    <font-awesome-icon icon="file-alt" style="color:#081F26;"/>
                                    {{ $t('maintenance.assessments.type.control_assessment') }}
                                  </span>
                                  <span v-if="project.type == 'bia_assessment'" class="badge">
                                    <font-awesome-icon icon="file-alt" style="color:#081F26;"/>
                                    {{ $t('maintenance.assessments.type.bia_assessment') }}
                                  </span>
                                </span>
                                <br>
                                <br>
                              </div>

                              <div v-if="project.assessment">
                                <span class="text-bold">
                                  {{ $t('table.template') }}:
                                </span>
                                <span>
                                  <br>
                                  <span class="badge">
                                    <font-awesome-icon icon="file-alt" style="color:#081F26;"/>
                                    {{ project.assessment.name }}
                                  </span>
                                </span>
                                <br>
                                <br>
                              </div>

                              <div v-if="project.scope">
                                <span class="text-bold">
                                  {{ $t('table.scope') }}:
                                </span>
                                <span>
                                  <br>
                                  <span class="badge" v-if="project.scope == 'policy'">
                                    <font-awesome-icon icon="crosshairs"/>
                                    {{ $t('projects.scope.policy') }}
                                  </span>
                                  <span class="badge" v-if="project.scope == 'system'">
                                    <font-awesome-icon icon="crosshairs"/>
                                    {{ $t('projects.system.label') }}
                                  </span>
                                  <span class="badge" v-if="project.scope == 'process'">
                                    <font-awesome-icon icon="crosshairs"/>
                                    {{ $t('projects.process.label') }}
                                  </span>
                                  <span class="badge" v-if="project.scope == 'activity'">
                                    <font-awesome-icon icon="crosshairs"/>
                                    {{ $t('projects.activity.label') }}
                                  </span>
                                  <span class="badge" v-if="project.scope == 'third_party'">
                                    <font-awesome-icon icon="crosshairs"/>
                                    {{ $t('projects.third_party.label') }}
                                  </span>
                                </span>
                                <br>
                                <br>
                              </div>

                              <div v-if="project.tags_translated && project.tags_translated.length">
                                <span class="text-bold">
                                  {{ $t('processes.table.tags') }}:
                                </span>
                                <br>
                                <span v-for="(tag, tag_index) in project.tags_translated" :key="tag_index" qid="p-tags-list">
                                  <span class="badge" :title="tag.name_translated">
                                    <font-awesome-icon icon="tag"/>
                                    {{ tag.name_translated }}
                                  </span>
                                </span>
                                <br>
                                <br>
                              </div>

                              <div v-if="project.users && project.users.length">
                                <span class="text-bold">
                                  {{ $t('projects.create.owners_label') }}:
                                </span>
                                <span v-for="(usr, usr_index) in project.users" :key="usr_index">
                                  <br>
                                  <span qid="profile-photo">
                                    <Avatar :object="usr" size="xs"></Avatar><span> {{ usr.name }}</span>
                                  </span>
                                </span>
                                <br>
                                <br>
                              </div>

                              <div v-if="project.data_collection_end_date">
                                <span class="text-bold">
                                  {{ $t('projects.schedule.data_due_date_label') }}:
                                </span>
                                <span>
                                  <br>
                                  <span class="badge">
                                    <font-awesome-icon icon="calendar-alt"/>
                                    {{ project.data_collection_end_date | formatDate }}
                                  </span>
                                </span>
                                <br>
                                <br>
                              </div>

                              <div v-if="project.end_date">
                                <span class="text-bold">
                                  {{ $t('projects.schedule.due_date_label') }}:
                                </span>
                                <span>
                                  <br>
                                  <span class="badge">
                                    <font-awesome-icon icon="calendar-alt"/>
                                    {{ project.end_date | formatDate }}
                                  </span>
                                </span>
                                <br>
                                <br>
                              </div>
                            </b-popover>

                            <td>
                              <router-link
                                  :to="{ name: 'projects.view', params: { slug: project.slug }}"
                                  qid="s-view-page-link"
                                  v-if="isOwner(project)"
                              >
                                {{ project.title }} <font-awesome-icon icon="up-right-from-square" class="color-success" />
                              </router-link>
                              <span v-if="!isOwner(project)"
                                    qid="project-name"
                              >
                                {{ project.title }}
                              </span>
                            </td>

                            <td>
                              <div class="">
                                <span class="text-normal" v-if="(project.status === 'pending' || project.status === 'in progress') || (project.control_type == 'continuous' && project.is_active_child_project)">
                                  <span v-if="getDifference(project.end_date) > 3">
                                    <font-awesome-icon icon="exclamation-triangle" class="risk-1"/>
                                    {{ $t('system.due_in') }}
                                    {{ getDifference(project.end_date) }}
                                    {{ $t('system.days') }}
                                  </span>

                                  <span v-if="getDifference(project.end_date) <= 3 && getDifference(project.end_date) >= 0">
                                    <font-awesome-icon icon="exclamation-triangle" class="risk-6"/>
                                    {{ $t('system.due_in') }}
                                    {{ getDifference(project.end_date) }}
                                    {{ $t('system.days') }}
                                  </span>

                                  <span v-if="getDifference(project.end_date) < 0">
                                    <font-awesome-icon icon="exclamation-triangle" class="risk-12"/>
                                    {{ Math.abs(getDifference(project.end_date)) }}
                                    {{ $t('system.days') }}
                                    {{ $t('system.overdue') }}
                                  </span>
                                </span>

                                <span class="text-normal" v-if="(project.control_type == 'continuous' && !project.is_active_child_project)">
                                  <span v-if="!project.is_active_child_project" class="pr-1">
                                    <font-awesome-icon icon="exclamation-triangle" class="risk-1"/>
                                    {{ $t('system.pending') }}
                                  </span>
                                </span>

                                <span class="text-normal" v-if="project.control_type == 'one time'">
                                    <span v-if="project.status === 'completed'" class="pr-1">
                                      <font-awesome-icon icon="check-circle" class="icon-success"/>
                                      {{ $t('system.completed') }}
                                    </span>
                                    <span v-if="project.status === 'closed'" class="pr-1">
                                      <font-awesome-icon icon="exclamation-triangle" class="risk-12"/>
                                      {{ $t('system.closed') }}
                                    </span>
                                </span>
                              </div>
                            </td>

                            <td>
                              <span>
                                <vm-progress
                                    type="circle"
                                    :percentage="project.progress"
                                    style="vertical-align: middle;"
                                    :width="40"
                                    :stroke-width="2"
                                    stroke-color="#00c29e"
                                >
                                  {{project.progress}}%
                                </vm-progress>
                              </span>
                            </td>

                            <td class="text-right">
                              <span v-if="project.status != 'closed' && project.status !='completed'"
                                    class="btn btn-success float-right"
                                    @click="showTask(project)"
                              >
                                {{ $t('system.view_project') }}
                              </span>
                            </td>
                          </tr>

                          <tr v-if="!loadingOpenProjects && !tableProjects.length" qid="no-results-row" class="text-center">
                            <td colspan="10">
                              <h5 class="mt-3">
                                {{ $t('system.no_results') }}
                              </h5>
                            </td>
                          </tr>
                          <tr v-if="loadingOpenProjects" qid="no-results-row-rr" class="text-center">
                            <td colspan="10">
                              <div class="mt-2 mb-4">
                                <div class="swing-container">
                                  <div class="swing">
                                    <div class="swing-l"></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div class="swing-r"></div>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="card-body">
                      <div class="pagination row">
                        <div class="col-md-6">
                          <div class="row">
                            <div class="float-left">
                              <span class="text-muted pagination-counter">
                                {{ $t('pagination.entries_per_page') }}:
                              </span>
                            </div>
                            <div class="float-left">
                              <multiselect
                                  v-model="perPage"
                                  :options="perPageOptions"
                                  track-by="value"
                                  label="value"
                                  :select-label="$t('system.dropdown_select_label')"
                                  :selected-label="$t('system.dropdown_selected_label')"
                                  :deselect-label="$t('system.dropdown_deselect_label')"
                                  qid="my-projects-per-page"
                                  @select="perPageChangedProjects"
                                  :placeholder="selectedPerPageProjects"
                                  @remove="perPageRemoved"
                              ></multiselect>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <b-pagination
                              class="float-right"
                              v-model="currentPageProjects"
                              :total-rows="totalRowsProjects"
                              :per-page="selectedPerPageProjects"
                              aria-controls="my-table"
                              @change="pageChangedProjects"
                              limit="1"
                          >
                            <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
                            <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
                            <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
                            <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
                            <div slot="ellipsis-text">
                              <b-spinner small type="grow"></b-spinner>
                              <b-spinner small type="grow"></b-spinner>
                              <b-spinner small type="grow"></b-spinner>
                            </div>
                            <span class="text-muted" slot="page" slot-scope="{ page, active }">
                              <span v-if="active">{{getPerPageProjects}}</span>
                            </span>
                          </b-pagination>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <ProjectViewModal
                    :slug="selectedProjectSlug"
                    :showModal="viewProjectModal"
                    @closeViewModal="closeViewProjectModal"
                ></ProjectViewModal>

                <!-- My tasks -->
                <div
                     class="table-container-dual"
                     :class="getClient.projectModule && (navigation.project || isGranted(permissions.MEASURE_CREATE)) ? 'col-md-6' : 'col-md-12'"
                >
                  <div class="card mt-3 pagination-margin" style="z-index:0;">
                    <div class="card-body">
                      <h5 class="mt-2">
                        <button class="btn btn-secondary-dark float-right"
                                @click="handleFilterButton(false)"
                        >
                          <font-awesome-icon icon="filter"/>
                        </button>
                        {{ $t('tasks.my_tasks') }}
                      </h5>
                      <div>
                        <span v-if="getGuide('my_todo_list_page')">
                          <GuideButton :guide="getGuide('my_todo_list_page')"></GuideButton>
                        </span>
                      </div>

                      <table class="table table-responsive-md table-list-secondary-slim">
                        <thead>
                          <tr>
                            <th scope="col">
                              {{ $t('projects.table.name') }}
                            </th>
                            <th scope="col">
                              {{ $t('projects.table.due_date') }}
                            </th>
                            <th scope="col">
                              {{ $t('table.progress') }}
                            </th>
                            <th scope="col" width="150"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(object, index) in tableTasks" :key="'tableTasks-row-' + index" :id="'tableTasks-row-' + index">

                            <b-popover
                                :target="'tableTasks-row-' + index"
                                boundary="viewport"
                                triggers="hover"
                                placement="top"
                                :delay="{ show: 500, hide: 0 }"
                            >
                              <div v-if="object.description" class="mt-2">
                                <span class="text-bold">
                                  {{ $t('maintenance.data_objects.table.description') }}:
                                </span>
                                <br>
                                {{ object.description | truncate(200)}}
                                <br>
                                <br>
                              </div>

                              <div v-if="object.type">
                                <span class="text-bold">
                                  {{ $t('table.type') }}:
                                </span>
                                <span>
                                  <br>
                                  <span v-if="object.type == 'update'" class="badge">
                                    <font-awesome-icon icon="sync-alt" style="color:#081F26;"/>
                                    {{ $t('projects.view.update_label') }}
                                  </span>
                                  <span v-if="object.type == 'validation'" class="badge">
                                    <font-awesome-icon icon="check-circle" style="color:#081F26;"/>
                                    {{ $t('projects.view.validation_label') }}
                                  </span>
                                  <span v-if="object.type == 'control'" class="badge">
                                    <font-awesome-icon icon="shield-alt" style="color:#081F26;"/>
                                    {{ $t('projects.view.control_label') }}
                                  </span>
                                  <span v-if="object.type == 'security_measure'" class="badge">
                                    <font-awesome-icon icon="shield-alt" style="color:#081F26;"/>
                                    {{ $t('projects.view.security_measure_label') }}
                                  </span>
                                  <span v-if="object.type == 'risk_assessment'" class="badge">
                                    <font-awesome-icon icon="file-alt" style="color:#081F26;"/>
                                    {{ $t('maintenance.assessments.type.risk_assessment') }}
                                  </span>
                                  <span v-if="object.type == 'control_assessment'" class="badge">
                                    <font-awesome-icon icon="file-alt" style="color:#081F26;"/>
                                    {{ $t('maintenance.assessments.type.control_assessment') }}
                                  </span>
                                  <span v-if="object.type == 'bia_assessment'" class="badge">
                                    <font-awesome-icon icon="file-alt" style="color:#081F26;"/>
                                    {{ $t('maintenance.assessments.type.bia_assessment') }}
                                  </span>
                                </span>
                                <br>
                                <br>
                              </div>

                              <div v-if="object.scope">
                                <span class="text-bold">
                                  {{ $t('table.scope') }}:
                                </span>
                                <span>
                                  <br>
                                  <span class="badge" v-if="object.scope == 'policy'">
                                    <font-awesome-icon icon="crosshairs"/>
                                    {{ $t('projects.scope.policy') }}
                                  </span>
                                  <span class="badge" v-if="object.scope == 'system'">
                                    <font-awesome-icon icon="crosshairs"/>
                                    {{ $t('projects.system.label') }}
                                  </span>
                                  <span class="badge" v-if="object.scope == 'process'">
                                    <font-awesome-icon icon="crosshairs"/>
                                    {{ $t('projects.process.label') }}
                                  </span>
                                  <span class="badge" v-if="object.scope == 'activity'">
                                    <font-awesome-icon icon="crosshairs"/>
                                    {{ $t('projects.activity.label') }}
                                  </span>
                                  <span class="badge" v-if="object.scope == 'third_party'">
                                    <font-awesome-icon icon="crosshairs"/>
                                    {{ $t('projects.third_party.label') }}
                                  </span>
                                </span>
                                <br>
                                <br>
                              </div>

                              <div v-if="object.users && object.users.length">
                                <span class="text-bold">
                                  {{ $t('projects.create.owners_label') }}:
                                </span>
                                <span v-for="(usr, usr_index) in object.users" :key="usr_index">
                                  <br>
                                  <span qid="profile-photo">
                                    <Avatar :object="usr" size="xs"></Avatar><span> {{ usr.name }}</span>
                                  </span>
                                </span>
                                <br>
                                <br>
                              </div>

                              <div v-if="object.data_collection_end_date && object.user_progress.data_task_count">
                                <span class="text-bold">
                                  {{ $t('projects.schedule.data_due_date_label') }}:
                                </span>
                                <span>
                                  <br>
                                  <span class="badge">
                                    <font-awesome-icon icon="calendar-alt"/>
                                    {{ object.data_collection_end_date | formatDate }}
                                  </span>
                                </span>
                                <br>
                                <br>
                              </div>

                              <div v-if="object.end_date && object.user_progress.task_count">
                                <span class="text-bold">
                                  {{ $t('projects.schedule.due_date_label') }}:
                                </span>
                                <span>
                                  <br>
                                  <span class="badge">
                                    <font-awesome-icon icon="calendar-alt"/>
                                    {{ object.end_date | formatDate }}
                                  </span>
                                </span>
                                <br>
                                <br>
                              </div>
                            </b-popover>


                            <td>
                              <a qid="system-name" class="default-color" @click="openViewProjectModal(object)">{{ object.title }} <font-awesome-icon icon="eye" class="color-success"/></a>
                            </td>

                            <td>
                              <div class="">
                                <span class="text-normal" v-if="(object.status === 'pending' || object.status === 'in progress') || (object.control_type == 'continuous' && object.is_active_child_project)">
                                  <span v-if="object.data_collection_end_date || (object.user_progress.data_task_count > 0 && object.user_progress.data_task_count != object.user_progress.data_task_count_completed)">

                                    <span v-if="getDifference(object.data_collection_end_date) > 3">
                                      <font-awesome-icon icon="exclamation-triangle" class="risk-1"/>
                                      {{ $t('system.due_in') }}
                                      {{ getDifference(object.data_collection_end_date) }}
                                      {{ $t('system.days') }}
                                    </span>

                                    <span v-if="getDifference(object.data_collection_end_date) <= 3 && getDifference(object.data_collection_end_date) >= 0">
                                      <font-awesome-icon icon="exclamation-triangle" class="risk-6"/>
                                      {{ $t('system.due_in') }}
                                      {{ getDifference(object.data_collection_end_date) }}
                                      {{ $t('system.days') }}
                                    </span>

                                    <span v-if="getDifference(object.data_collection_end_date) < 0">
                                      <font-awesome-icon icon="exclamation-triangle" class="risk-12"/>
                                      {{ Math.abs(getDifference(object.data_collection_end_date)) }}
                                      {{ $t('system.days') }}
                                      {{ $t('system.overdue') }}
                                    </span>
                                  </span>

                                  <span v-else>
                                    <span v-if="getDifference(object.end_date) > 3">
                                      <font-awesome-icon icon="exclamation-triangle" class="risk-1"/>
                                      {{ $t('system.due_in') }}
                                      {{ getDifference(object.end_date) }}
                                      {{ $t('system.days') }}
                                    </span>

                                    <span v-if="getDifference(object.end_date) <= 3 && getDifference(object.end_date) >= 0">
                                      <font-awesome-icon icon="exclamation-triangle" class="risk-6"/>
                                      {{ $t('system.due_in') }}
                                      {{ getDifference(object.end_date) }}
                                      {{ $t('system.days') }}
                                    </span>

                                    <span v-if="getDifference(object.end_date) < 0">
                                      <font-awesome-icon icon="exclamation-triangle" class="risk-12"/>
                                      {{ Math.abs(getDifference(object.end_date)) }}
                                      {{ $t('system.days') }}
                                      {{ $t('system.overdue') }}
                                    </span>
                                  </span>
                                </span>

                                <span class="text-normal" v-if="(object.control_type == 'continuous' && !object.is_active_child_project)">
                                  <span v-if="!object.is_active_child_project" class="pr-1">
                                    <font-awesome-icon icon="exclamation-triangle" class="risk-1"/>
                                    {{ $t('system.pending') }}
                                  </span>
                                </span>

                                <span class="text-normal" v-if="object.control_type == 'one time'">
                                  <span v-if="object.status === 'completed'" class="pr-1">
                                    <font-awesome-icon icon="check-circle" class="icon-success"/>
                                    {{ $t('system.completed') }}
                                  </span>
                                  <span v-if="object.status === 'closed'" class="pr-1">
                                    <font-awesome-icon icon="exclamation-triangle" class="risk-12"/>
                                    {{ $t('system.closed') }}
                                  </span>
                                </span>
                              </div>
                            </td>

                            <td>
                              <span>
                                <vm-progress
                                    type="circle"
                                    :percentage="object.user_progress.progress"
                                    style="vertical-align: middle;"
                                    :width="40"
                                    :stroke-width="2"
                                    stroke-color="#00c29e"
                                >
                                  {{object.user_progress.progress}}%
                                </vm-progress>
                              </span>
                            </td>

                            <td class="text-right">
                              <b-button class="mr-2"
                                        variant="success"
                                        @click="openViewProjectModal(object)"
                                        qid="delete-s-cancel-button"
                              >

                                  <span>
                                    {{ $t('tasks.open_tasks') }}
                                  </span>
                              </b-button>

                            </td>
                          </tr>

                          <tr v-if="!loadingOpen && !tableTasks.length" qid="no-results-row" class="text-center">
                            <td colspan="10">
                              <h5 class="mt-3">
                                {{ $t('system.no_results') }}
                              </h5>
                            </td>
                          </tr>
                          <tr v-if="loadingOpen" qid="no-results-row-rr" class="text-center">
                            <td colspan="10">
                              <div class="mt-2 mb-4">
                                <div class="swing-container">
                                  <div class="swing">
                                    <div class="swing-l"></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div class="swing-r"></div>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="card-body">
                      <div class="pagination row">
                        <div class="col-md-6">
                          <div class="row">
                            <div class="float-left">
                              <span class="text-muted pagination-counter">
                                {{ $t('pagination.entries_per_page') }}:
                              </span>
                            </div>
                            <div class="float-left">
                              <multiselect
                                  v-model="perPage"
                                  :options="perPageOptions"
                                  track-by="value"
                                  label="value"
                                  :select-label="$t('system.dropdown_select_label')"
                                  :selected-label="$t('system.dropdown_selected_label')"
                                  :deselect-label="$t('system.dropdown_deselect_label')"
                                  qid="create-org-form-organization-level"
                                  @select="perPageChanged"
                                  :placeholder="selectedPerPage"
                                  @remove="perPageRemoved"
                              ></multiselect>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <b-pagination
                              class="float-right"
                              v-model="currentPage"
                              :total-rows="rows"
                              :per-page="selectedPerPage"
                              aria-controls="my-table"
                              @change="pageChanged"
                              limit="1"
                          >
                            <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
                            <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
                            <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
                            <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
                            <div slot="ellipsis-text">
                              <b-spinner small type="grow"></b-spinner>
                              <b-spinner small type="grow"></b-spinner>
                              <b-spinner small type="grow"></b-spinner>
                            </div>
                            <span class="text-muted" slot="page" slot-scope="{ page, active }">
                              <span v-if="active">{{getPerPage}}</span>
                            </span>
                          </b-pagination>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-2 filter-container">
                  <div class="card mt-3">
                    <div class="card-body">
                      <b-form-group>
                        <label qid="filter-tp-type-label">
                          {{ $t('projects.table.type') }}
                        </label>
                        <multiselect
                            v-model="filters.type"
                            @select="debounceInput"
                            @remove="debounceInput"
                            :placeholder="$t('projects.table.type')"
                            :options="types"
                            :multiple="true"
                            select-label="✔"
                            selected-label="✔"
                            deselect-label="x"
                            :taggable="false"
                            track-by="value"
                            label="name"
                        ></multiselect>
                      </b-form-group>
                      <b-form-group>
                        <label qid="filter-tp-type-label">
                          {{ $t('projects.table.scope') }}
                        </label>
                        <multiselect
                            v-model="filters.scope"
                            :options="scopes"
                            :placeholder="$t('projects.table.scope')"
                            @select="debounceInput"
                            @remove="debounceInput"
                            select-label="✔"
                            selected-label="✔"
                            deselect-label="x"
                            track-by="value"
                            label="name"
                            qid="filter-tp-form-type"
                        ></multiselect>
                      </b-form-group>
                      <b-form-group>
                        <label qid="filter-tp-type-label">
                          {{ $t('system.status') }}
                        </label>
                        <multiselect
                            v-model="filters.status"
                            :options="statuses"
                            :placeholder="$t('system.status')"
                            @select="debounceInput"
                            @remove="debounceInput"
                            select-label="✔"
                            selected-label="✔"
                            deselect-label="x"
                            track-by="value"
                            label="name"
                            qid="filter-tp-form-type"
                        >
                          <template slot="option" slot-scope="props">
                            <span v-if="props.option.value == 'completed'">
                              <font-awesome-icon icon="check-circle" class="icon-success mr-2" style="background:white;border-radius:50%;"/>
                              {{ $t('system.completed') }}
                            </span>
                            <span v-if="props.option.value == 'in progress'">
                              <font-awesome-icon icon="exclamation-triangle" class="risk-6 mr-2"/>
                              {{ $t('system.in_progress') }}
                            </span>
                          </template>
                          <template slot="singleLabel" slot-scope="props">
                            <span v-if="props.option.value == 'completed'">
                              <font-awesome-icon icon="check-circle" class="icon-success mr-2" style="background:white;border-radius:50%;"/>
                              {{ $t('system.completed') }}
                            </span>
                            <span v-if="props.option.value == 'in progress'">
                              <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2"/>
                              {{ $t('system.in_progress') }}
                            </span>
                          </template>
                        </multiselect>
                      </b-form-group>

                      <a href="#"
                         @click="resetFilters"
                         class="text-right"
                         qid="filter-tp-reset"
                      >
                        {{ $t('system.reset_filters') }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </b-tab>


      <!-- Rejected validations tab -->
      <b-tab @click="validationsTabClicked" :title-link-class="validationCount ? 'position-relative pr-5' : 'position-relative'" v-if="getClient && getClient.id && (getClient.processingActivitiesModule || getClient.systemModule || getClient.contractBasicModule)">
        <template v-slot:title>
          {{$t('system.rejected_validations_title')}}
          <span class="tab-item-badge ml-2" v-if="validationCount">
            {{validationCount}}
          </span>
        </template>
        <!-- Rejected validations widget -->
        <div v-if="showValidationsTab">
          <RejectedValidations></RejectedValidations>
        </div>
      </b-tab>





    </b-tabs>


    <!-- Crop image modal -->
    <b-modal ref="crop-image" hide-footer size="lg">
      <div class="d-block text-center">
        <h4 qid="edit-profile-modal-title">
          {{ $t('Crop image') }}
        </h4>
      </div>
      <div class="form-container" style="max-height: 600px;">
        <img v-bind:src="imageToCrop"
             qid="profile-photo"
             id="crop"
        >
      </div>
      <div class="text-right">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideCropModal"
                  qid="edit-profile-cancel-button"
        >
          {{ $t('profile.password.cancel') }}
        </b-button>
        <b-button type="submit"
                  class="mt-3 ml-3"
                  variant="success"
                  id="crop-button"
                  :disabled="buttonDisabled"
                  qid="edit-profile-submit-button"
        >
          <span v-if="buttonDisabled" class="mr-1">
            <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
          </span>
          {{ $t('profile.password.submit') }}
        </b-button>
      </div>
    </b-modal>


    <b-modal
       ref="view-project"
       @hide="hideViewProjectModal"
       size="xl"
       modal-class="task-modal"
    >

      <template #modal-header="{ close }">
        <div class="text-center" style="width: 100%;">
          <span @click="hideViewProjectModal" class="btn btn-secondary cursor-pointer float-right">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-2" v-if="selectedProject">
            {{ $t('projects.tasks_modal.title') }}
            <router-link
                :to="{ name: 'projects.view', params: { slug: selectedProject.slug }}"
                qid="s-view-page-link"
                class="breadcrumb-item ml-2"
                v-if="isOwner(selectedProject)"
            >
              <font-awesome-icon icon="calendar-alt" class="mr-1 breadcrumb-item"/>
              {{ selectedProject.title }}
            </router-link>
            <span v-if="!isOwner(selectedProject)" class="ml-2 text-success breaducrumb-item" style="pointer-events:none;">
              <font-awesome-icon icon="calendar-alt" class="mr-1"/>
              {{ selectedProject.title }}
            </span>
          </h5>
        </div>
      </template>


      <table class="table table-responsive-md table-list-secondary" v-if="selectedProject.type!='control_assessment'">
        <thead>
          <tr>
            <th>
              {{ $t('projects.table.name') }}
            </th>
            <th>
              {{ $t('table.asset') }}
            </th>
            <th>
              {{ $t('tasks.table.task_assignee') }}
            </th>
            <th>
              {{ $t('system.status') }}
            </th>
            <th width="320"></th>
          </tr>
        </thead>

        <tbody v-if="open_tasks && open_tasks.length">
          <tr v-for="(object, index) in open_tasks" :key="index">
            <td>
              <span v-if="object.code === 'business_risk_assessment' || object.code === 'privacy_risk_assessment' || object.code === 'system_impact_assessment'">
                {{ $t('maintenance.assessments.system_impact_assessment_label') }}
              </span>
              <span v-else>
                <span v-if="selectedProject.type && (selectedProject.type === 'update' || selectedProject.type === 'validation')">
                  {{ $t('tasks.values.' + $options.filters.slugify(object.title)) }}
                </span>
                <span v-else>
                  {{ object.full_title}}
                </span>
              </span>
            </td>

            <td>
              <span v-if="object.model" class="text-normal">
                <font-awesome-icon
                  icon="desktop"
                  size="lg"
                  class="mr-1"
                  v-if="object.model.who_am_i === 'App\\System\\Models\\System'"/>
                <font-awesome-icon
                  icon="cubes"
                  size="lg"
                  class="mr-1"
                  v-if="object.model.who_am_i === 'App\\Activity\\Models\\Activity'"/>
                <font-awesome-icon
                  icon="cube"
                  size="lg"
                  class="mr-1"
                  v-if="object.model.who_am_i === 'App\\Process\\Models\\Process'"/>
                <font-awesome-icon
                  icon="file-signature"
                  size="lg"
                  class="mr-1"
                  v-if="object.model.who_am_i === 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'"/>
                <font-awesome-icon
                  icon="file-invoice"
                  size="lg"
                  class="mr-1"
                  v-if="object.model.who_am_i === 'App\\Maintenance\\Policy\\Models\\Policy'"/>
                {{ object.model.name }}
              </span>
              <span v-if="!object.model" class="text-normal">
                {{ $t('tasks.modal.content_deleted') }}
              </span>
            </td>

            <td>
              <span class="mr-1" v-for="(user, index) in object.users" :key="index">
                <span qid="profile-photo">
                  <Avatar :object="user" size="xs"></Avatar>
                </span>
              </span>
            </td>

            <td>
              <span v-if="object.status === 'completed'" >
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="object.status === 'pending'" class="pr-2">
                <font-awesome-icon
                    icon="exclamation-triangle"
                    class="risk-6"
                />
              </span>
              <span class="text-normal">
                {{ $t('system.' + $options.filters.slugify(object.status)) }}
              </span>
            </td>

            <td class="text-right">
              <b-button class="ml-2"
                        variant="light"
                        @click="showEditUsersModal(object)"
                        qid="delete-s-cancel-button"
                        v-if="object.status === 'pending' && (isOwner(object) || isDataOwner(object) || isOwner(selectedProject))"
              >
                {{ $t('tasks.re_assign_button') }}
              </b-button>
              <AssessmentTaskModal
                  class=""
                  :task="object"
                  :tasks="selectedProject"
                  :fromHomepage="true"
                  @reloadContent="loadProjectTasks()"
                  v-if="(selectedProject.type === 'risk_assessment' || selectedProject.type === 'bia_assessment') && object.status === 'pending'"
              ></AssessmentTaskModal>
              <AssessmentGlobalSingleTaskModal
                  class=""
                  :task="object"
                  :tasks="selectedProject"
                  :fromHomepage="true"
                  @reloadContent="loadProjectTasks()"
                  v-if="selectedProject.type === 'control_assessment' && object.status === 'pending'"
              ></AssessmentGlobalSingleTaskModal>
              <RiskTaskModal
                  class=""
                  :task="object"
                  :tasks="selectedProject"
                  :fromHomepage="true"
                  @reloadContent="loadProjectTasks()"
                  v-if="(selectedProject.type === 'control' || selectedProject.type === 'security_measure') && object.status === 'pending'"
              ></RiskTaskModal>
              <UpdateTaskModal
                  class=""
                  :task="object"
                  :tasks="selectedProject"
                  :fromHomepage="true"
                  @reloadContent="loadProjectTasks()"
                  v-if="selectedProject.type === 'update' && object.status === 'pending'"
              ></UpdateTaskModal>
              <ValidationTaskModal
                  class=""
                  :task="object"
                  :tasks="selectedProject"
                  :fromHomepage="true"
                  @reloadContent="loadProjectTasks()"
                  v-if="selectedProject.type === 'validation' && object.status === 'pending'"
              ></ValidationTaskModal>

              <b-button class="mr-2"
                        variant="success"
                        @click="showViewTaskModal(object)"
                        qid="delete-s-cancel-button"
                        v-if="object.status === 'completed' && selectedProject.type !== 'update' && selectedProject.type !== 'validation'"
              >
                {{ $t('tasks.view_button') }}
              </b-button>
            </td>
          </tr>
        </tbody>

        <tbody v-if="open_tasks && !open_tasks.length && !loadingTasks">
          <tr qid="no-results-row" class="text-center">
            <td colspan="10">
              <h5 class="mt-3">
                {{ $t('system.no_results') }}
              </h5>
            </td>
          </tr>
        </tbody>

        <tbody v-if="loadingTasks">
          <tr qid="no-results-row-rr" class="text-center">
            <td colspan="10">
              <div class="mt-2 mb-4">
                <div class="swing-container">
                  <div class="swing">
                    <div class="swing-l"></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div class="swing-r"></div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>


      <!-- Radio Buttons -->
      <div class="mb-3" v-if="selectedProject.type=='control_assessment'">
        <label class="">
          <input type="radio" v-model="selectedTaskType" value="doc_collection_tasks" @change="onTaskTypeChange"/>
          Documentation collection tasks
        </label><br />
        <label class="">
          <input type="radio" v-model="selectedTaskType" value="main_tasks" @change="onTaskTypeChange"/>
          Main tasks
        </label>

      </div>

      <table class="table table-responsive-md table-list-secondary" v-if="selectedProject.type=='control_assessment'">
        <thead>
        <tr>
          <th @click="sortBy('name')" class="cursor-pointer">
            {{ $t('projects.table.name') }}
            <font-awesome-icon class="text-muted" icon="sort" v-if="sortColumn !== 'name'"/>
            <font-awesome-icon icon="caret-down" v-if="sortOrder === 'desc' && sortColumn === 'name'"/>
            <font-awesome-icon icon="caret-up" v-if="sortOrder === 'asc' && sortColumn === 'name'"/>

          </th>
          <th v-if="selectedTaskType === 'main_tasks'">
            {{ $t('tasks.table.task_responsible') }}
          </th>
          <th v-if="selectedTaskType === 'doc_collection_tasks' && selectedProject.type === 'control_assessment'">
            {{ $t('tasks.table.data_collection_assignee') }}
          </th>
          <th @click="sortBy('status')" class="cursor-pointer" v-if="selectedTaskType === 'main_tasks'">
            {{ $t('system.status') }}
            <font-awesome-icon class="text-muted" icon="sort" v-if="sortColumn !== 'status'"/>
            <font-awesome-icon icon="caret-down" v-if="sortOrder === 'desc' && sortColumn === 'status'"/>
            <font-awesome-icon icon="caret-up" v-if="sortOrder === 'asc' && sortColumn === 'status'"/>
          </th>
          <th @click="sortBy('data_status')" class="cursor-pointer" v-if="selectedTaskType === 'doc_collection_tasks'">
            {{ $t('system.status') }}
            <font-awesome-icon class="text-muted" icon="sort" v-if="sortColumn !== 'data_status'"/>
            <font-awesome-icon icon="caret-down" v-if="sortOrder === 'desc' && sortColumn === 'data_status'"/>
            <font-awesome-icon icon="caret-up" v-if="sortOrder === 'asc' && sortColumn === 'data_status'"/>
          </th>
          <th width="320"></th>
        </tr>
        </thead>

        <tbody v-if="open_tasks && open_tasks.length">
        <tr v-for="(object, index) in open_tasks" :key="index">
          <td>
            <span v-if="object.code=='update_measures'">
              {{ $t('projects.measures.system_description_title') }}
            </span>
            <span v-else>
              {{ object.reference }}: {{ object.title }}
            </span>

          </td>

          <td v-if="selectedTaskType === 'main_tasks'">
              <span class="mr-1" v-for="(user, index) in object.users" :key="index">
                <span qid="profile-photo">
                  <Avatar :object="user" size="xs"></Avatar>
                </span>
              </span>
          </td>

          <td v-if="selectedTaskType === 'doc_collection_tasks' && selectedProject.type === 'control_assessment'">
              <span class="mr-1" v-for="(user, index) in object.data_users" :key="index">
                <span qid="profile-photo">
                  <Avatar :object="user" size="xs"></Avatar>
                </span>
              </span>
          </td>

          <td v-if="selectedTaskType === 'main_tasks'">

              <span v-if="object.status === 'completed'" >
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>

              <span v-if="object.status === 'pending' || !object.status" class="pr-2">
                <font-awesome-icon
                        icon="exclamation-triangle"
                        class="risk-6"
                />
              </span>
              <span class="text-normal" v-if="object.status">
                {{ $t('system.' + $options.filters.slugify(object.status)) }}
              </span>
              <span class="text-normal" v-else>
                {{ $t('system.pending') }}
              </span>
          </td>
          <td v-if="selectedTaskType === 'doc_collection_tasks'">

              <span v-if="object.data_status === 'completed'" >
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>

              <span v-if="object.data_status === 'pending' || !object.data_status" class="pr-2">
                <font-awesome-icon
                        icon="exclamation-triangle"
                        class="risk-6"
                />
              </span>
              <span class="text-normal" v-if="object.data_status">
                {{ $t('system.' + $options.filters.slugify(object.data_status)) }}
              </span>
              <span class="text-normal" v-else>
                {{ $t('system.pending') }}
              </span>

          </td>


          <td class="text-right">
            <b-button class="ml-2"
                      variant="light"
                      @click="showEditUsersModal(object)"
                      qid="delete-s-cancel-button"
                      v-if="selectedTaskType === 'main_tasks' && object.status != 'completed'"
            >
              {{ $t('tasks.re_assign_button') }}
            </b-button>
            <b-button class="ml-2"
                      variant="light"
                      @click="showEditUsersModal(object)"
                      qid="delete-s-cancel-button"
                      v-if="selectedTaskType === 'doc_collection_tasks' && (object.status != 'completed' && object.data_status != 'completed')"
            >
              {{ $t('tasks.re_assign_button') }}
            </b-button>
            <AssessmentTaskModal
                    class=""
                    :task="object"
                    :tasks="selectedProject"
                    :fromHomepage="true"
                    @reloadContent="loadProjectTasks()"
                    v-if="(selectedProject.type === 'risk_assessment' || selectedProject.type === 'bia_assessment') && ((object.status === 'pending' && !isDataUser(object)) || ((object.data_status === 'pending' || !object.data_status) && isDataUser(object)))"
            ></AssessmentTaskModal>



            <AssessmentGlobalSingleTaskModal
                    class=""
                    :task="object"
                    :tasks="selectedProject"
                    :fromHomepage="true"
                    :selectedTaskType="selectedTaskType"
                    @reloadContent="loadProjectTasks()"
                    v-if="selectedProject.type === 'control_assessment' && ((object.status === 'pending' && !isDataUser(object)) || ((object.data_status === 'pending' || !object.data_status) && isDataUser(object)))"
            ></AssessmentGlobalSingleTaskModal>
            <RiskTaskModal
                    class=""
                    :task="object"
                    :tasks="selectedProject"
                    :fromHomepage="true"
                    @reloadContent="loadProjectTasks()"
                    v-if="(selectedProject.type === 'control' || selectedProject.type === 'security_measure') && ((object.status === 'pending' && !isDataUser(object)) || ((object.data_status === 'pending' || !object.data_status) && isDataUser(object)))"
            ></RiskTaskModal>
            <UpdateTaskModal
                    class=""
                    :task="object"
                    :tasks="selectedProject"
                    :fromHomepage="true"
                    @reloadContent="loadProjectTasks()"
                    v-if="selectedProject.type === 'update' && ((object.status === 'pending' && !isDataUser(object)) || ((object.data_status === 'pending' || !object.data_status) && isDataUser(object)))"
            ></UpdateTaskModal>
            <ValidationTaskModal
                    class=""
                    :task="object"
                    :tasks="selectedProject"
                    :fromHomepage="true"
                    @reloadContent="loadProjectTasks()"
                    v-if="selectedProject.type === 'validation' && ((object.status === 'pending' && !isDataUser(object)) || ((object.data_status === 'pending' || !object.data_status) && isDataUser(object)))"
            ></ValidationTaskModal>

            <b-button class="mr-2"
                      variant="light"
                      @click="showViewTaskModal(object)"
                      qid="delete-s-cancel-button"
                      v-if="!isDataUser(object) && object.status === 'completed' && selectedProject.type !== 'update' && selectedProject.type !== 'validation'"
            >
              {{ $t('tasks.view_button') }}
            </b-button>
            <b-button class="mr-2"
                      variant="light"
                      @click="showViewTaskModal(object)"
                      qid="delete-s-cancel-button"
                      v-if="isDataUser(object) && object.data_status === 'completed' && selectedProject.type !== 'update' && selectedProject.type !== 'validation'"
            >
              {{ $t('tasks.view_button') }}
            </b-button>
          </td>
        </tr>
        </tbody>

        <tbody v-if="open_tasks && !open_tasks.length && !loadingTasks">
        <tr qid="no-results-row" class="text-center">
          <td colspan="10">
            <h5 class="mt-3">
              {{ $t('system.no_results') }}
            </h5>
          </td>
        </tr>
        </tbody>

        <tbody v-if="loadingTasks">
        <tr qid="no-results-row-rr" class="text-center">
          <td colspan="10">
            <div class="mt-2 mb-4">
              <div class="swing-container">
                <div class="swing">
                  <div class="swing-l"></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div class="swing-r"></div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="pagination row">
        <div class="col-md-6">
          <div class="row">
            <div class="float-left">
              <span class="text-muted pagination-counter">
                {{ $t('pagination.entries_per_page') }}:
              </span>
            </div>
            <div class="float-left">
              <multiselect
                  v-model="tasksPerPage"
                  :options="perPageOptions"
                  track-by="value"
                  label="value"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="create-org-form-organization-level"
                  @select="tasksPerPageChanged"
                  :placeholder="tasksSelectedPerPage"
                  @remove="tasksPerPageRemoved"
              ></multiselect>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <b-pagination
              class="float-right"
              v-model="tasksCurrentPage"
              :total-rows="tasksRows"
              :per-page="tasksSelectedPerPage"
              aria-controls="my-table-1"
              @change="tasksPageChanged"
              limit="1"
          >
            <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
            <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
            <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
            <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
            <div slot="ellipsis-text">
              <b-spinner small type="grow"></b-spinner>
              <b-spinner small type="grow"></b-spinner>
              <b-spinner small type="grow"></b-spinner>
            </div>
            <span class="text-muted" slot="page" slot-scope="{ page, active }">
              <span v-if="active">{{getTasksPerPage}}</span>
            </span>
          </b-pagination>
        </div>
      </div>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">
                <!-- Switch Component -->
                <b-form-checkbox v-model="taskLoaded" name="check-button" switch class="icon-success" @input="loadProjectTasks(1, perPage)">
                  <span class="text-white">Show all tasks (including completed tasks)</span>
                </b-form-checkbox>
              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class="mt-3"
                            variant="secondary"
                            @click="hideViewProjectModal"
                            qid="create-rr-cancel-button"
                  >
                    {{ $t('system.close') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

    </b-modal>


    <!-- Re-assign modal -->
    <b-modal ref="re-assign" @hide="hideEditUsersModal" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditUsersModal" class="btn btn-secondary cursor-pointer float-right">
            <font-awesome-icon icon="times"/>
          </span>

          <div class="d-block text-center">
            <h4 qid="re_assign-users-title">
              {{ $t('tasks.re_assign.title') }}
            </h4>
          </div>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="re_assign-users-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="reassignUsers" qid="re_assign-users-form" v-if="selectedTask && selectedTask.model">
        <div class="form-container">
          <b-form-group>
            <span v-if="isOwner(selectedTask) && selectedTaskType === 'main_tasks'">
              <label qid="re_assign-users-label">
                {{ $t('tasks.table.task_responsible') }}
              </label>

              <div class="multiselect-row">
                <multiselect
                    v-model="selectedAssignUsers"
                    :options="allUsers"
                    :disabled="buttonDisabled"
                    :multiple="true"
                    :taggable="false"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    track-by="slug"
                    :placeholder="$t('projects.create.owners_placeholder')"
                    label="name"
                    qid="re_assign-users-select"
                >
                  <template slot="tag" slot-scope="props">
                    <span class="mr-3 user-tag">
                      <Avatar :object="props.option" size="xs"></Avatar>
                      <span class="ml-2">
                        {{ props.option.name }}
                      </span>
                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <Avatar :object="props.option" size="xs"></Avatar>
                    <span class="ml-2">
                      {{ props.option.name }}
                    </span>
                  </template>
                </multiselect>

                <UserInviteModal
                      :buttonType="'small'"
                      :buttonDisabled=buttonDisabled
                      @reloadUserList="reloadUserList"
                ></UserInviteModal>
              </div>
              <br>
            </span>

            <span v-if="isDataOwner(selectedTask) && selectedTaskType === 'doc_collection_tasks'">
              <label qid="re_assign-data-users-label">
                {{ $t('tasks.table.data_collection_assignee') }}
              </label>

              <div class="multiselect-row">
                <multiselect
                    v-model="selectedAssignDataUsers"
                    :options="allUsers"
                    :disabled="buttonDisabled"
                    :multiple="true"
                    :taggable="false"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    track-by="slug"
                    :placeholder="$t('projects.create.owners_placeholder')"
                    label="name"
                    qid="re_assign-users-select"
                >
                  <template slot="tag" slot-scope="props">
                      <span class="mr-3 user-tag">
                        <Avatar :object="props.option" size="xs"></Avatar>
                        <span class="ml-2">
                          {{ props.option.name }}
                        </span>
                      </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <Avatar :object="props.option" size="xs"></Avatar>
                    <span class="ml-2">
                        {{ props.option.name }}
                      </span>
                  </template>
                </multiselect>

                <UserInviteModal
                    :buttonType="'small'"
                    :buttonDisabled=buttonDisabled
                    @reloadUserList="reloadUserList"
                ></UserInviteModal>
              </div>
            </span>
          </b-form-group>
        </div>
      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">
              </div>
              <div class="col-sm-6 text-right">
                <b-button class="mt-3"
                          variant="secondary"
                          @click="hideEditUsersModal"
                          qid="re_assign-users-cancel-button"
                >
                  {{ $t('projects.create.cancel') }}
                </b-button>
                <b-button type="submit"
                          class="mt-3 ml-3"
                          variant="success"
                          :disabled="buttonDisabled"
                          @click="reassignUsers"
                          qid="re_assign-users-submit-button"
                >
                  <span v-if="buttonDisabled" class="mr-1">
                    <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                  </span>
                  {{ $t('projects.create.submit') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <TaskViewModal
        :selectedTask="selectedTask"
        :showModal="viewTaskModal"
        @closeViewModal="hideViewTaskModal"
    ></TaskViewModal>


  </div>
</template>

<script>

import piincHttp from '@/util/configureAxios.js';
// import HomepageTreeView from '@/components/HomepageTreeView.vue';
import roleCheck from '@/util/ACL/roleCheck';
import RejectedValidations from '@/components/RejectedValidations.vue';
import Avatar from '@/components/Avatar.vue';
import AssessmentTaskModal from '@/views/Tasks/AssessmentTaskModal.vue';
import AssessmentGlobalTaskModal from '@/views/Tasks/AssessmentGlobalTaskModal.vue';
import AssessmentGlobalSingleTaskModal from '@/views/Tasks/AssessmentGlobalSingleTaskModal.vue';
import RiskTaskModal from '@/views/Tasks/RiskTaskModal.vue';
import UpdateTaskModal from '@/views/Tasks/UpdateTaskModal.vue';
import ValidationTaskModal from '@/views/Tasks/ValidationTaskModal.vue';
import TaskViewModal from '@/views/Tasks/TaskViewModal.vue';
import GuideButton from '@/components/guide/GuideButton.vue';
import CreateProjectModal from '@/views/Projects/CreateProjectModal.vue';
import ProjectViewModal from '@/views/Projects/ProjectViewModal.vue';
import UserInviteModal from '@/components/user/UserInviteModal.vue';


// import VueCropper from 'vue-cropperjs';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  name: 'Home',
  data() {
    return {
      myGuides: [],
      navigation: [],
      users_total: 0,
      users_position: 0,
      topUserListOpened: false,
      topUsers: {},
      organizations_total: 0,
      organizations_position: 0,
      topOrganizationListOpened: false,
      topOrganizations: [],
      loadingOrganizations: true,
      allUsers: [],
      statistics: {},
      myProjectsOpen: [],
      validations: [],
      loadingOpen: true,
      loadingOpenProjects: true,
      projectsShowMore: true,
      projectsPage: 1,
      loadingValidations: true,
      validationsShowMore: true,
      validationsPage: 1,
      taskForm: {
        remarks: ''
      },
      taskSwitchOptions: [
        {text: this.$t('system.yes'), value: 1},
        {text: this.$t('system.no'), value: 0},
      ],
      filterOpened: false,
      error: '',
      selectedTask: [],
      viewTaskModal: false,
      selectedAssignUsers: [],
      selectedAssignDataUsers: [],
      buttonDisabled: false,
      selectedFile: {},
      selectedLink: {},
      showDeleteAttachmentModal: false,
      showDeleteLinkModal: false,
      showInput: false,
      showSingleLinkLabel: true,
      inputLink: '',
      showFullProjectMessage: false,
      showFullGenericControlDescription: false,
      tabIndex: 0,
      showButton: false,
      avatar: '',
      avatarLarge: '',
      imageToCrop: '',
      userForm: {
        name: '',
        email: '',
        phone: '',
        file: {}
      },
      cropper: {},
      user: {},
      showNameInput: false,
      showPhoneInput: false,
      userName: '',
      userPhone: '',
      showValidationsTab: false,
      tableTasks: [],
      tableProjects: [],
      selectedProject: {},
      open_tasks: [],
      loadingTasks: false,
      unreadCount: 0,
      validationCount: 0,

      // Project progress modal
      selectedProjectSlug: '',
      viewProjectModal: false,

      // Pagination
      perPage: '',
      perPageOptions: [
        { name: '10', value: '10' },
        { name: '20', value: '20' },
        { name: '50', value: '50' },
        { name: '100', value: '100' }
      ],

      //Project pagination
      selectedPerPageProjects: '10',
      currentPageProjects: 1,
      totalRowsProjects: 0,

      //Task pagination
      selectedPerPage: '10',
      currentPage: 1,
      totalRows: 0,

      // Task modal pagination
      tasksPerPage: '',
      tasksCurrentPage: 1,
      tasksSelectedPerPage: '10',
      tasksTotalRows: 0,
      taskLoaded: 0,
      // Task filter
      filters: {
        type: [],
        scope: '',
        status: ''
      },
      types: [
        { name: this.$t('projects.view.update_label'), value: 'update' },
        { name: this.$t('projects.view.validation_label'), value: 'validation' },
        { name: this.$t('projects.view.control_label'), value: 'control' },
        { name: this.$t('projects.view.security_measure_label'), value: 'security_measure' },
        { name: this.$t('maintenance.assessments.type.risk_assessment'), value: 'risk_assessment' },
        { name: this.$t('maintenance.assessments.type.control_assessment'), value: 'control_assessment' },
        { name: this.$t('maintenance.assessments.type.bia_assessment'), value: 'bia_assessment' }
      ],
      scopes: [
        { name: this.$t('projects.scope.policy'), value: 'policy' },
        { name: this.$t('projects.system.label'), value: 'system' },
        { name: this.$t('projects.process.label'), value: 'process' },
        { name: this.$t('projects.activity.label'), value: 'activity' },
        { name: this.$t('projects.third_party.label'), value: 'third_party' }
      ],
      statuses: [
        { name: this.$t('system.completed'), value: 'completed' },
        { name: this.$t('system.in_progress'), value: 'in progress' }
      ],
      sortColumn: 'name',
      sortOrder: 'asc',
      taskType: 'main',
      selectedTaskType: ''
    };
  },
  components: {
    // HomepageTreeView,
    Avatar,
    AssessmentTaskModal,
    AssessmentGlobalTaskModal,
    AssessmentGlobalSingleTaskModal,
    RiskTaskModal,
    UpdateTaskModal,
    ValidationTaskModal,
    // VueCropper,
    RejectedValidations,
    TaskViewModal,
    GuideButton,
    CreateProjectModal,
    ProjectViewModal,
    UserInviteModal
  },
  watch: {
    // Watch when client changes in store and trigger api reload
    getClient: function (newValue, oldValue) {
      let self = this;
      this.loadTopFastestUsers()
      this.trialExpiredRedirect()
      this.loadNavigation()

      if (newValue.projectModule) {

        setTimeout(function(){
          // Empty the gauge element on client change
          const gaugeElement = document.getElementById("gauge");
          gaugeElement.innerHTML = '';
          self.loadStatistics()
        }, 300);

      }

      this.loadProjects()
      this.loadTasks()
      this.loadGuides('my_todo_list_page');
      this.loadGuides('process_list_page');
      if (this.getUser && this.getUser.slug) {
        this.loadUser()
      }
      this.avatarLarge = this.getProfileAvatar;
      this.loadCount()
      this.loadValidationCount()
    },
    getReloadPage: function () {
      this.loadProjects()
      this.loadTasks()
    },
    getUser: function (newValue) {
      if (newValue && newValue.slug) {
        if (this.getClient && this.getClient.slug) {
          this.loadUser()
        }
      }
    }
  },
  computed: {
    getClient() {
      return this.$store.state.client
    },
    getUser() {
      return this.$store.state.user
    },
    getProfileAvatar(){
      let user = this.user;
      if (user.avatar_large) {
        return user.avatar_large;
      } else {
        return require('@/assets/avatar.png');
      }
    },
    getMyProjects() {
      return this.myProjectsOpen
    },
    getReloadPage() {
      return this.$store.state.updatePage
    },
    getUserClients() {
      return this.$store.state.user.clients
    },
    getStorePerPage() {
      return this.$store.state.perPage
    },
    getPerPage() {
      let page = this.currentPage;
      let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
      let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
      let selectedOf = this.totalRows;

      if (selectedTo > selectedOf) {
        selectedTo = selectedOf
      }

      return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
    },
    getPerPageProjects() {
      let page = this.currentPageProjects;
      let selectedFrom = (page-1) * Number(this.selectedPerPageProjects) + 1;
      let selectedTo = (page-1) * Number(this.selectedPerPageProjects) + Number(this.selectedPerPageProjects);
      let selectedOf = this.totalRowsProjects;

      if (selectedTo > selectedOf) {
        selectedTo = selectedOf
      }

      return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
    },
    getTasksPerPage() {
      let page = this.tasksCurrentPage;
      let selectedFrom = (page-1) * Number(this.tasksSelectedPerPage) + 1;
      let selectedTo = (page-1) * Number(this.tasksSelectedPerPage) + Number(this.tasksSelectedPerPage);
      let selectedOf = this.tasksTotalRows;

      if (selectedTo > selectedOf) {
        selectedTo = selectedOf
      }

      return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
    },
    rows() {
      // Use computed value for rows because of dynamic update
      return this.totalRows
    },
    tasksRows() {
      // Use computed value for rows because of dynamic update
      return this.tasksTotalRows
    }
  },
  methods: {
    sortBy(column) {
      // Toggle sort order if the same column is clicked again
      if (this.sortColumn === column) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortOrder = 'asc'; // Default to ascending order
      }

      this.loadProjectTasks(1,this.perPage,this.sortColumn, this.sortOrder)
    },
    isOwner(object) {
      let self = this;
      let allow = false;
      let existingUser = _.find(object.users, function(user) {
        return user.id === self.getUser.id;
      });

      if (existingUser) {
        allow = true;
      } else {
        if (roleCheck('Client admin') || roleCheck('Partition admin') || roleCheck('Validator') || this.getUser.isAdmin) {
          allow = true;
        }
      }

      return allow;
    },
    isDataOwner(object) {
      let self = this;
      let existingUser = _.find(object.data_users, function(user) {
        return user.id === self.getUser.id;
      });

      return existingUser;
    },
    isDataUser(object) {
      let self = this;
      let existingUser = _.find(object.data_users, function(user) {
        return user.id === self.getUser.id;
      });

      let existingTaskUser = _.find(object.users, function(user) {
        return user.id === self.getUser.id;
      });

      if(existingTaskUser){
        return false;
      }

      if(existingUser){
        return true;
      }

      return false;
    },
    getGuide(code) {
      let existingGuide = _.find(this.myGuides, function(object) {
        return object.scope == code && object.enabled
      });
      return existingGuide
    },
    loadGuides(code) {
      let self = this;
      let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', { params:
        {
          per_page: 1,
          language: 'en',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function(response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0])
        }
      }, function() {});
    },
    debounceInput: _.debounce(function() {
      this.loadTasks()
    }, 400),
    reloadContent() {
      this.loadProjects(this.currentPageProjects, this.selectedPerPageProjects)
      this.loadTasks(this.currentPage, this.selectedPerPage)
      this.loadCount()
      this.loadValidationCount()
      this.$store.commit('storeReloadCount');
    },
    resetFilters() {
      this.filters.type = []
      this.filters.scope = ''
      this.filters.status = ''

      this.debounceInput()
    },
    handleFilterButton(forceOpened) {
      if (forceOpened) {
        this.filterOpened = true
      } else {
        this.filterOpened = !this.filterOpened
      }
    },
    pageChanged(page) {
      this.loadTasks(page)
    },
    pageChangedProjects(page) {
      this.loadProjects(page)
    },
    perPageChanged(perPage) {
      let self = this;
      self.selectedPerPage = perPage.value
      this.$store.commit('storePerPage', this.selectedPerPage);
      // Load content when page changed listener is triggered
      this.loadProjects(1, perPage.value)
      this.loadTasks(1, perPage.value)
    },
    perPageChangedProjects(perPage) {
      let self = this;
      self.selectedPerPageProjects = perPage.value
      this.$store.commit('storePerPage', this.selectedPerPageProjects);
      // Load content when page changed listener is triggered
      this.loadProjects(1, perPage.value)
      this.loadTasks(1, perPage.value)
    },
    perPageRemoved() {
      let self = this;
      // Load content when page changed listener is triggered
      self.selectedPerPage = self.perPageOptions[0].value
      self.selectedPerPageProjects = self.perPageOptions[0].value
      this.loadTasks(1, self.selectedPerPage)
      this.loadProjects(1, self.selectedPerPageProjects)
    },
    tasksPageChanged(page) {
      this.loadProjectTasks(page)
    },
    tasksPerPageChanged(perPage) {
      let self = this;
      self.tasksSelectedPerPage = perPage.value
      this.$store.commit('storePerPage', this.tasksSelectedPerPage);
      // Load content when page changed listener is triggered
      this.loadProjectTasks(1, perPage.value)
    },
    tasksPerPageRemoved() {
      let self = this;
      // Load content when page changed listener is triggered
      self.tasksSelectedPerPage = self.perPageOptions[0].value
      this.loadProjectTasks(1, self.tasksSelectedPerPage)
    },
    showViewTaskModal(object) {
      this.selectedTask = object
      this.viewTaskModal = true
    },
    hideViewTaskModal() {
      this.selectedTask = {}
      this.viewTaskModal = false
    },
    hideEditUsersModal() {
      this.selectedTask = {};
      this.selectedAssignUsers = [];
      this.selectedAssignDataUsers = [];
      this.$refs['re-assign'].hide();
    },
    reloadUserList() {
      let object = this.selectedTask

      this.$refs['re-assign'].hide();
      this.showEditUsersModal(object);
    },
    showEditUsersModal(object) {
      let self = this;
      let task = object;
      let role_name = [self.permissions.ROLE_CLIENT_ADMIN];

      this.error = '';
      this.buttonDisabled = true;
      this.loading = true;

      piincHttp.get('tasks/' + object.id).then(function(response) {
        task = response.data;

        if (task.project.type === 'control' || task.project.type === 'security_measure' || task.project.type === 'control_assessment') {
          role_name.push(self.permissions.ROLE_MEMBER);
          role_name.push(self.permissions.ROLE_VALIDATOR);
        }

        if (self.getClient && self.getClient.parent) {
          role_name.push(self.permissions.ROLE_PARTITION_ADMIN);
        }

        self.selectedAssignUsers = [];
        self.selectedAssignDataUsers = [];
        piincHttp.get('users', { params:
          {
            client: self.getClient.id,
            role_name: role_name,
            per_page: 100
          }
        }).then(function(response) {
          let users = response.data.items;

          _.forEach(object.users, function (user) {
            if (_.findIndex(users, function(o) { return o.id === user.id; }) === -1) {

                users.push(user);

            }

              let matchedUser = _.cloneDeep(user);
              if (user.id === object.owner) {
                matchedUser.owner = true;
              }
              self.selectedAssignUsers.push(matchedUser);

          })

          _.forEach(object.data_users, function (user) {
            if (_.findIndex(users, function(o) { return o.id === user.id; }) === -1) {

                users.push(user);

            }

              let matchedUser = _.cloneDeep(user);
              if (user.id === object.owner) {
                matchedUser.owner = true;
              }
              self.selectedAssignDataUsers.push(matchedUser);

          })

          self.allUsers = _.uniq(users);
            self.buttonDisabled = false;
            self.loading = false;
        }, function() {
          self.buttonDisabled = false;
          self.loading = false;
        });
      }, function() {
        self.buttonDisabled = false;
        self.loading = false;
      });

      this.selectedTask = object;
      this.$refs['re-assign'].show();
    },
    reassignUsers(evt) {
      evt.preventDefault();

      this.buttonDisabled = true;

      if (this.isOwner(this.selectedTask)) {
        this.reassignFormSubmit();

        if (this.isDataOwner(this.selectedTask)) {
          this.reassignDataFormSubmit();
          this.hideEditUsersModal();
          // this.loadProjectTasks();
        } else {
          this.hideEditUsersModal();
          // this.loadProjectTasks();
        }
      } else {
        if (this.isDataOwner(this.selectedTask)) {
          this.reassignDataFormSubmit();
          this.hideEditUsersModal();
          // this.loadProjectTasks();
        } else {
          this.hideEditUsersModal();
          // this.loadProjectTasks();
        }
      }

      this.buttonDisabled = false;
    },
    reassignFormSubmit() {
      //this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      let userIds = [];

      if (this.selectedAssignUsers && this.selectedAssignUsers.length) {
        for (var i = 0; i < this.selectedAssignUsers.length; i++) {
          userIds.push(this.selectedAssignUsers[i].id);
        }
      }

      if (userIds && userIds.length) {
        piincHttp.put('tasks/' + this.selectedTask.id, {
          users: userIds,
          reasign: 'replace'
        }).then(function() {
          // self.hideEditUsersModal();
          self.loadProjectTasks();
          self.$toastr('success', self.$t('tasks.re_assign.success'))
          // self.buttonDisabled = false;
        }, function(error) {
          if (error.status !== 200) {
            // self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      } else {
        self.error = self.$t('tasks.re_assign.required')
        //self.buttonDisabled = false;
      }
    },
    reassignDataFormSubmit() {
      //this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      let userIds = [];

      if (this.selectedAssignDataUsers && this.selectedAssignDataUsers.length) {
        for (var i = 0; i < this.selectedAssignDataUsers.length; i++) {
          userIds.push(this.selectedAssignDataUsers[i].id);
        }
      }

      if (userIds && userIds.length) {
        piincHttp.put('tasks/' + this.selectedTask.id, {
          data_users: userIds,
          reasign: 'replace'
        }).then(function() {
          // self.hideEditUsersModal();
          self.loadProjectTasks();
          self.$toastr('success', self.$t('tasks.re_assign.success'))
          // self.buttonDisabled = false;
        }, function(error) {
          if (error.status !== 200) {
            // self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      } else {
        self.error = self.$t('tasks.re_assign.required')
        //self.buttonDisabled = false;
      }
    },
    loadProjectTasks(page, perPage, sort = 'name', order = 'asc') {
      let self = this;
      this.loadingTasks = true;

      let status = ['pending']
      if(this.taskLoaded){
        status = ['pending','completed']
      }

      if (this.getStorePerPage) {
        this.tasksSelectedPerPage = this.getStorePerPage;
      }

      // If page is not defined, set page to default 1
      let pageNumber = page ? page : 1;
      let perPageNumber = perPage ? perPage : this.tasksSelectedPerPage;

      piincHttp.get('projects/' + this.selectedProject.slug + '/tasks/me/small', { params:
        {
          page: pageNumber,
          per_page: perPageNumber,
          status: status,
          sort: sort,
          order: order,
          type: this.selectedTaskType
        }
      }).then(function(response) {
        console.log(response.data.items)
        // self.open_tasks = []
        self.open_tasks = response.data.items;
        // Set number of total items
        self.tasksTotalRows = response.data.total_count;
        self.loadingTasks = false;
      }, function() {});
    },
    openViewProjectModal(object) {
      this.selectedProject = object;

      if( this.selectedProject.type == "control_assessment"){
        this.selectedTaskType = 'doc_collection_tasks';
      }else{
        this.selectedTaskType = 'main_tasks'
      }

      this.loadProjectTasks();
      this.$refs['view-project'].show();
    },
    hideViewProjectModal() {
      this.selectedProject = {};
      this.open_tasks = [];
      this.tasksPerPage = '';
      this.tasksCurrentPage = 1;
      this.tasksTotalRows = 0;
      this.$refs['view-project'].hide();
    },
    showNameInputFunction() {
      this.showNameInput = true
      this.userName = this.user.name
      let self = this
      setTimeout(function(){
        self.$refs.nameInput.$el.focus();
      }, 100);
    },
    hideNameInputFunction() {
      this.showNameInput = false
    },
    showPhoneInputFunction() {
      this.showPhoneInput = true
      this.userPhone = this.user.phone
      let self = this
      setTimeout(function(){
        self.$refs.phoneInput.$el.focus();
      }, 100);
    },
    hidePhoneInputFunction() {
      this.showPhoneInput = false
    },
    validationsTabClicked() {
      this.showValidationsTab = true;
    },
    saveName() {
      let self = this;
      if (this.userName) {
        piincHttp.put('users/' + self.getUser.slug, {
          name: this.userName
        }).then(function(response) {

          response.data.clients = self.getUserClients;
          // Store returned user in store if my profile
          self.$store.commit('storeUser', response.data);
          self.showNameInput = false;
          self.loadUser()
        }, function(error) {
          if (error.status !== 200) {
            self.error = error.data.message;
          }
        })
      }

    },
    savePhone() {
      let self = this;
      piincHttp.put('users/' + self.getUser.slug, {
        phone: this.userPhone
      }).then(function(response) {

        response.data.clients = self.getUserClients;
        // Store returned user in store if my profile
        self.$store.commit('storeUser', response.data);
        self.showPhoneInput = false;
        self.loadUser()
      }, function(error) {
        if (error.status !== 200) {
          self.error = error.data.message;
        }
      })
    },
    showCropModal() {
      let sizeError = false;
      let self = this

      this.$refs['crop-image'].show()
      this.buttonDisabled = false;

      setTimeout(function(){
        const image = document.getElementById('crop');
        const cropper = new Cropper(image, {
          aspectRatio: 1,
          viewMode: 2,
          crop(event) {

          },
        });

        document.getElementById('crop-button').addEventListener('click', function(){
          self.buttonDisabled = true;

          cropper.getCroppedCanvas().toBlob(function (blob) {
            var formData = new FormData();
            formData.append('croppedImage', blob);

            if (blob.size > 10485760) {
              sizeError = true;
            }

            formData.append("avatar", blob);
            formData.append("_method", 'put');

            if (sizeError) {
              self.error = self.$t('system.file_size')
              alert(self.error)
            } else {
              piincHttp.post('users/' + self.getUser.slug, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }).then(function(response) {
                  response.data.clients = self.getUserClients;
                  // Store returned user in store if my profile
                  self.$store.commit('storeUser', response.data);
                  self.hideCropModal()
              }, function(error) {
                self.buttonDisabled = false;
                self.userForm.error = error.data.message;
                if (error.data.errors.avatar) {
                  self.userForm.error += ' ' + error.data.errors.avatar[0]
                }
                alert(self.userForm.error)
              })
            }

          });

        })
      }, 500);

    },
    hideCropModal() {
      this.loadUser()
      this.$refs['crop-image'].hide()
    },
    onFileChange(file) {
      this.userForm.file = file;
      const avatar = file.target.files[0];
      this.avatar = URL.createObjectURL(avatar);
      this.avatarLarge = URL.createObjectURL(avatar);
      this.imageToCrop = URL.createObjectURL(avatar);

      this.showCropModal()

    },
    removePhoto() {
      let self = this;
      let formData = new FormData();
      formData.append("avatar", null);
      formData.append("_method", 'put');

      piincHttp.post('users/' + this.getUser.slug, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function(response) {
        response.data.clients = self.getUserClients;
        self.$store.commit('storeUser', response.data);
        self.avatar = '';
      }, function(error) {})
    },
    resetFile() {
      let imagefile = document.querySelector('#file-photo');
      imagefile.value = '';
    },
    changePhoto() {
      let self = this;
      let sizeError = false;
      let formData = new FormData();
      let imagefile = document.querySelector('#file-photo');
      const avatar = imagefile.files[0];
      this.avatar = URL.createObjectURL(avatar);
      this.avatarLarge = URL.createObjectURL(avatar);

      // Equal to 10 MB
      if (imagefile.files[0].size > 10485760) {
        sizeError = true;
      }

      formData.append("avatar", imagefile.files[0]);
      formData.append("_method", 'put');

      if (sizeError) {
        this.error = this.$t('system.file_size')
        alert(this.error)
      } else {
        piincHttp.post('users/' + this.getUser.slug, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function(response) {
            response.data.clients = self.getUserClients;
            // Store returned user in store if my profile
            self.$store.commit('storeUser', response.data);

        }, function(error) {
          self.buttonDisabled = false;
          self.userForm.error = error.data.message;
          if (error.data.errors.avatar) {
            self.userForm.error += ' ' + error.data.errors.avatar[0]
          }
          alert(self.userForm.error)
        })
      }
    },
    downloadMedia(object){
      piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.download = object.file_name;

        link.click();
        link.remove()
        window.URL.revokeObjectURL(url);
      }, function() {});
    },
    showHideDescription(object, index) {
      object.showDescription =!object.showDescription;
      this.$set(this.myProjectsOpen, index, object)
    },
    getDifference(endDate) {
      var moment = require('moment');
      let currentDate = moment()
      endDate = moment(endDate);
      let difference = endDate.diff(currentDate, 'days');
      return difference;
    },
    goToValidation(validation) {
      if (validation.relation.who_am_i === 'App\\Process\\Models\\Process') {
        if (validation.type === 'legal_basis' ||
            validation.type === 'information_obligation' ||
            validation.type === 'risk_profile' ||
            validation.type === 'confidentiality' ||
            validation.type === 'integrity' ||
            validation.type === 'availability'
        ) {
          this.tabIndex = 1;
        }
        if (validation.type === 'risk_scenario') {
          this.tabIndex = 2;
        }
        this.$router.push({name: 'processes.view', params: {slug: validation.relation.slug, tabIndex: this.tabIndex, validation: validation.type}})
      }
      if (validation.relation.who_am_i === 'App\\System\\Models\\System') {
        if (validation.type === 'access_control' ||
            validation.type === 'log_management' ||
            validation.type === 'network' ||
            validation.type === 'data_discovery'
        ) {
          this.tabIndex = 2;
        }
        if (validation.type === 'risk_scenario') {
          this.tabIndex = 3;
        }
        this.$router.push({name: 'systems.view', params: {slug: validation.relation.slug, tabIndex: this.tabIndex, validation: validation.type}})
      }
      if (validation.relation.who_am_i === 'App\\Activity\\Models\\Activity') {
        if (validation.type === 'mapping_description') {
          this.tabIndex = 1;
        }
        if (validation.type === 'retention_rule' ||
            validation.type === 'integrity_check' ||
            validation.type === 'processing_type'
        ) {
          this.tabIndex = 2;
        }
        if (validation.type === 'risk_scenario') {
          this.tabIndex = 3;
        }
        this.$router.push({name: 'activities.view', params: {slug: validation.relation.slug, tabIndex: this.tabIndex, validation: validation.type}})
      }
      if (validation.relation.who_am_i === 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
        if (validation.type === 'risk_scenario') {
          this.tabIndex = 3;
        }
        if (validation.type === 'third_party') {
          this.tabIndex = 8;
        }
        this.$router.push({name: 'contracts.view', params: {slug: validation.relation.slug, tabIndex: this.tabIndex, validation: validation.type}})
      }
      if (validation.relation.who_am_i === 'App\\RiskScenario\\Models\\RiskScenario') {
        if (validation.type === 'risk_scenario') {
          this.tabIndex = 4;
        }
        this.$router.push({name: 'risk_scenarios.view', params: {slug: validation.relation.slug, tabIndex: this.tabIndex, validation: validation.type}})
      }
      if (validation.relation.who_am_i === 'App\\GenericControl\\Models\\GenericControl') {
        if (validation.type === 'generic_control') {
          this.tabIndex = 4;
        }
        this.$router.push({name: 'generic_controls.view', params: {slug: validation.relation.slug, tabIndex: this.tabIndex, validation: validation.type}})
      }
    },
    goToMyTodo() {
      this.$router.push('/tasks')
    },
    openTopUsersList() {
      this.topUserListOpened = this.topUserListOpened ? false : true;
    },
    openTopOrganizationsList() {
      this.topOrganizationListOpened = this.topOrganizationListOpened ? false : true;
    },
    loadTopFastestUsers() {
      let self = this;

      this.loadingOrganizations = true;

      self.organizations_total = 0;
      self.organizations_position = 0;

      piincHttp.get('tasks/top-users', { params:
        {
          client: this.getClient.slug,
        }
      }).then(function(response) {

        if(response.data.organizations.total_count){
          self.organizations_total = response.data.organizations.total_count;
          self.organizations_position = response.data.organizations.position;
        }
        self.topOrganizations = response.data.organizations.items;
        self.loadingOrganizations = false;
      });
    },
    loadTasks(page, perPage) {
      let formTypes = [];

      if (this.getStorePerPage) {
        this.selectedPerPage = this.getStorePerPage;
      }

      if (this.filters.type && this.filters.type.length) {
        for (var t = 0; t < this.filters.type.length; t++) {
          formTypes[t] = this.filters.type[t].value;
        }
        this.handleFilterButton(true)
      }

      // If page is not defined, set page to default 1
      let pageNumber = page ? page : 1;
      let perPageNumber = perPage ? perPage : this.selectedPerPage;
      let self = this;

      this.loadingOpen = true;
      piincHttp.get('projects/me', { params:
        {
          page: pageNumber,
          per_page: perPageNumber,
          status: this.filters.status ? this.filters.status.value : 'in progress',
          type: formTypes ? formTypes : undefined,
          scope: this.filters.scope ? this.filters.scope.value : undefined,
          sort: 'end_date',
          order: 'asc',
          client: this.getClient.slug
        }
      }).then(function(response) {

        self.tableTasks = response.data.items;
        // Set number of total items
        self.totalRows = response.data.total_count;
        self.loadingOpen = false;
      }, function() {});
    },
    loadProjects(page, perPage) {
      let formTypes = [];

      if (this.getStorePerPage) {
        this.selectedPerPage = this.getStorePerPage;
      }

      // If page is not defined, set page to default 1
      let pageNumber = page ? page : 1;
      let perPageNumber = perPage ? perPage : this.selectedPerPageProjects;
      let self = this;

      this.loadingOpenProjects = true;
      piincHttp.get('projects', { params:
        {
          page: pageNumber,
          per_page: perPageNumber,
          status: ['in progress', 'pending'],
          sort: 'end_date',
          control_type: 'one time',
          order: 'asc',
          client: this.getClient.slug,
          owners: [this.getUser.id]
        }
      }).then(function(response) {

        self.tableProjects = response.data.items;
        // Set number of total items
        self.totalRowsProjects = response.data.total_count;
        self.loadingOpenProjects = false;
      }, function() {});
    },
    loadUser(){
      let self = this;
      piincHttp.get('users/' + this.getUser.slug, { params:
        {
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.user = response.data;
      }, function() {});
    },
    loadStatistics(){
      let self = this;
      piincHttp.get('tasks/user-performance', { params:
        {
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.statistics = response.data;

        if (!self.statistics.percentage) {
          self.statistics.percentage = 0
        }

        var Gauge = require("svg-gauge");
        var gauge = Gauge(
        document.getElementById("gauge"),
          {
            max: 100,
            dialStartAngle: 180,
            dialEndAngle: -90,
            viewBox: "0 0 67 67",
            value: self.statistics.percentage,
            label: function(value) {
              return value + "%";
            },
          }
        );

      }, function() {});
    },
    loadCount() {
      let self = this;
      if (this.getClient.projectModule) {
        piincHttp.get('projects/me/tasks', { params:
          {
            count: 1,
            status: 'pending',
            client: this.getClient.slug
          }
        }).then(function (response) {
          self.unreadCount = response.data.total_count;
        }, function () {});
      }
    },
    loadValidationCount() {
      let self = this;
      piincHttp.get('validations/rejected', { params:
        {
          count: 1,
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.loading = false;
        self.validationCount = response.data.total_count;
      }, function() {});

    },
    trialExpiredRedirect() {
      var moment = require('moment');
      let self = this;

      setTimeout(function(){
        let currentDate = moment()
        let endDate = moment(self.getClient.trial_ends_at);
        let difference = endDate.diff(currentDate, 'days');

        if ((self.getClient.subscription_status == 'trial_expired' && difference < 1) || self.getClient.subscription_status == 'subscription_ended') {
          self.$router.push({ name: 'clientProfile', params: { slug: self.getClient.slug }, query: { tabindex: 1 }})
        }
      }, 500);

    },
    showTask(object) {
      this.selectedProjectSlug = object.slug;
      this.viewProjectModal = true;
    },
    closeViewProjectModal(statusChanged) {
      this.selectedProjectSlug = '';
      this.viewProjectModal = false;

      if (statusChanged) {
        this.loadProjects();
        this.loadTasks();
      }
    },
    loadNavigation() {
      let self = this;
      piincHttp.get('users/me/navigation', { params:
        {
          client: this.getClient.slug
        }
      }).then(function (response) {
        self.navigation = response.data;
      }, function () {});
    },
    onTaskTypeChange() {
      // Logic to be executed when radio button selection changes
      console.log('Task type changed to:', this.selectedTaskType);

      // Call any method you need, like fetching tasks based on the selected type
      this.loadProjectTasks(1, this.perPage, 'id', 'asc');
    }
  },
  created() {
    if (this.getClient && this.getClient.slug) {

      this.trialExpiredRedirect()
      this.loadNavigation()
      this.loadValidationCount()

      if (this.getUser && this.getUser.slug) {
        this.loadUser()
      }
      this.loadTopFastestUsers()
      this.loadStatistics()
      if (this.getClient.projectModule) {
        this.loadProjects()
        this.loadTasks()
        this.loadCount()

      }

      this.loadGuides('my_todo_list_page');
      this.loadGuides('process_list_page');
    }
  }
}

</script>
